export default {
  isNumeric(str) {
    // if (typeof str != "string") return false // we only process strings!
    return (
      !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
      !isNaN(parseFloat(str))
    ); // ...and ensure strings of whitespace fail
  },
  containsAnyLetters(str) {
    return /[a-zA-Z]/.test(str);
  },
  hasWhiteSpace(s) {
    return s.indexOf(' ') >= 0;
  }
};
